import { injectable, inject } from 'inversify'
import type { IQrCodeBase64Options } from '@/services/qrCode/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type { QrCodeWorkerService } from '@/services/workers/qrcode/QrCodeWorkerService'

@injectable()
export class QrCodeService {
  constructor(@inject(SERVICE_TYPES.QrCodeWorkerService) protected readonly qrCodeWorkerService: QrCodeWorkerService) {}

  public async getBase64(text: string, options: IQrCodeBase64Options) {
    return this.qrCodeWorkerService.toDataUrl(text, {
      errorCorrectionLevel: 'H',
      type: 'image/png',
      color: { dark: '#000000' },
      ...options,
    })
  }

  public formatForSms<P extends string, M extends string>(phoneNumber: P, message: M): `SMSTO:${P}:${M}` {
    return `SMSTO:${phoneNumber}:${message}`
  }
}
